import { render } from "./basics.vue?vue&type=template&id=c200fbd4&lang=pug"
import script from "./basics.vue?vue&type=script&lang=js"
export * from "./basics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__